module.exports = __webpack_public_path__ + "media/images/home/ezcater-56ddd5d620273556bcb470ae345d76d5.png";